import UsageService from '../UsageService';

export default class ReportUsageService extends UsageService {
  // TODO placeholder
}
